import Store from '@get-bridge/learn-legacy-shared/dist/core/Store';
import Cache from '@get-bridge/learn-legacy-shared/dist/core/Cache';
import getDirectReports from '../data_requests/getDirectReports';
import UserPayload from '../schemas/UserPayload';
import { FetchStatus } from '../../constants';
import Promise from 'Promise';
import APIPayload from '@get-bridge/learn-legacy-shared/dist/core/APIPayload';

export default Store({
  schema: UserPayload,

  initialize() {
    this.searchStatus = FetchStatus.UNSENT;

    this.managerCache = Cache(this.emitChange, {
      schema: UserPayload,
      displayName: 'GlobalNav__UserStore__manager',
    });
    this.directReportsCache = Cache(this.emitChange, {
      schema: UserPayload,
      displayName: 'GlobalNav__UserStore__directReport',
    });
    this.searchCache = Cache(this.emitChange, {
      schema: UserPayload,
      displayName: 'GlobalNav__UserStore__search',
    });
  },

  clear() {
    this.managerCache.clear();
    this.directReportsCache.clear();
    this.searchCache.clear();
  },

  fetchManager(managerId) {
    return getDirectReports({
      managerId,
      params: {
        'includes[]': 'manager',
      },
    }).then(result => {
      this.managerCache.add(result.manager);
    });
  },

  getManager(managerId) {
    return this.managerCache.get(managerId);
  },

  fetchDirectReports(managerId) {
    return getDirectReports({ managerId }).then(result => {
      this.directReportsCache.setCollection({}, result.directReports);
    });
  },

  getDirectReports() {
    return this.directReportsCache.getCollection({});
  },

  search(term, user, manager) {
    this.searchStatus = FetchStatus.LOADING;
    this.emitChange();

    const normalizedUser = APIPayload.of(UserPayload)(user);
    const normalizedManager = APIPayload.of(UserPayload)(manager);

    return new Promise(resolve => {
      let users = [normalizedUser];

      if (normalizedManager) {
        users = users.concat(normalizedManager);
      }

      users = users.concat(this.getDirectReports());
      resolve(users);
    })
      .then(users =>
        users.filter(
          user => user.fullName.toLowerCase().indexOf(term.toLowerCase()) > -1,
        ),
      )
      .then(filteredUsers => {
        this.searchStatus = FetchStatus.DONE;
        this.searchCache.setCollection({}, filteredUsers);
        return filteredUsers;
      });
  },

  getSearchResults() {
    return this.searchCache.getCollection({});
  },
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/users/stores/UserStore.js